import { CustomerDetailsFormNew_MX } from './mixed';
import { CustomerDetailsFormNew_PL } from './privateLease';

export const CustomerDetailsFormNew = {
  /**
   * FinancialProduct
   */
  FP: CustomerDetailsFormNew_PL,
  /**
   * PrivateLease
   */
  PL: CustomerDetailsFormNew_PL,
  /**
   * ServicePlan
   */
  SP: CustomerDetailsFormNew_MX,
};
